import { z as zod } from 'zod';
import { SimpleIntroSchema } from "@/app/features/sites/cooperations/types/schema";
import { ShowroomSchema } from "@/app/features/shared/types/schema";
import { LinkSchema } from "@/app/features/shared/__to_be_integrated/types/forms/LinkSchema";
import { MediaRefSchema } from "@/app/features/shared/__to_be_integrated/types/forms/MediaRefSchema";
import { Enum_Historyevent_Showdateas } from "@/app/lib/generated/graphql-types";

export const SiteHistorySchema = zod.object({
    intro: SimpleIntroSchema.omit({ id: true }),
    showroom: ShowroomSchema.nullish(),
});

export const HistoryEventSchema = zod.object({
    title: zod.string().min(1, 'Titel darf nicht leer sein'),
    description: zod.string().min(1, 'Beschreibung darf nicht leer sein'),
    startDate: zod.string().date('Ungültiges Startdatum'),
    endDate: zod.string().date('Ungültiges Enddatum').nullish(),
    showDateAs: zod.nativeEnum(Enum_Historyevent_Showdateas),
    image: MediaRefSchema.nullish(),
    links: zod.array(LinkSchema).nullish(),
    readMore: MediaRefSchema.nullish(),
}).superRefine((event, context) => {
    if (event.endDate && event.endDate < event.startDate) {
        context.addIssue({
            code: zod.ZodIssueCode.custom,
            path: ['endDate'],
            message: 'Das Enddatum darf nicht vor dem Startdatum liegen',
        });
    }
});
